import { Box, Button, Stack, Typography } from "@mui/material";
import { Link, useRouteError } from "react-router-dom";
import { isAxiosError } from "../../utils/helpers";

function getErrorMessage(error: unknown) {
  if (isAxiosError(error)) {
    return `The server responded with: ${error.response?.status} ${error.response?.statusText}.`;
  } else {
    return String(error);
  }
}

export function UnknownError() {
  const error = useRouteError();
  return (
    <Stack flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" marginTop={10} gap={1}>
      <Box title="Phoenix was here!" sx={{ fontSize: 64 }}>
        😥
      </Box>
      <Typography variant="h4">The page had an unexpected error.</Typography>
      <Typography variant="body1">{getErrorMessage(error)}</Typography>
      <Typography paddingY={2} fontSize={18}>
        Please try again, or contact support if the problem persists.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ minWidth: 200 }}>
        Return home
      </Button>
    </Stack>
  );
}
